import { render, staticRenderFns } from "./XTabBasedForm.vue?vue&type=template&id=19d4227a&"
import script from "./XTabBasedForm.vue?vue&type=script&lang=ts&"
export * from "./XTabBasedForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../tbestpro-management/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports